export const ROUTE_NAMES = {
	MAP: '/map',
};
